<template>
    <grid-container template="main" :color="'gray-200'">
        <router-view v-slot="{ Component }" name="rail">
            <template v-if="Component">
                <suspense>
                    <component :is="Component" />
                    <template #fallback>
                        rail
                    </template>
                </suspense>
            </template>
        </router-view>

        <grid-area area="content" :style="noPadding ? { padding: 0 } : null">
            <flex-container height="full" :gap="null">
                <flex-container
                    id="warnings"
                    size="full"
                    direction="column"
                />
                <router-view v-slot="{ Component }">
                    <template v-if="Component">
                        <suspense>
                            <component :is="Component" />
                            <template #fallback>
                                <spinner-loader />
                            </template>
                        </suspense>
                    </template>
                </router-view>
            </flex-container>
        </grid-area>
    </grid-container>
</template>

<script setup lang="ts">
    import { GridContainer, GridArea } from '@keyvue/one-ui';
    import { RouterView, useRouter } from 'vue-router';
    import { computed } from 'vue';

    const router = useRouter();
    const noPadding = computed(() => router.currentRoute.value.meta?.noPadding === true);
</script>
